import React from "react"
import { ProdutosData } from "../../../../../../types/contratos-data-interface"

interface ProdutoProps {
  produto: ProdutosData
}

export const Produto = ({ produto }: ProdutoProps) => {
  return (
    <div className="px-4 py-2  rounded-md border w-full flex flex-col text-gray-700 my-2 text-sm">
      <div className="flex gap-8 mb-2">
        <p className=""><strong className="font-semibold">ID:</strong> {produto?.id}</p>
        <p className=""><strong className="font-semibold">Data da compra:</strong> {produto?.datacompra}</p>
      </div>
      <p className=""><strong className="font-semibold">Produto:</strong> {produto?.descricao}</p>
    </div>
  )
}